module.exports = __webpack_public_path__ + "img/illu-verification-phone.0d9454dc.svg";